import React, { useEffect, useState } from "react";
import Layout from "./../layouts/Index";
import { connect } from "react-redux";
import BlockLoader from "./../contentloaders/BlockLoader";
import {
  Row,
  Col,
  Container,
  Button,
  Table,
} from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { getPromoCodes } from "./../../store/actions/PromoCodeActions";
import moment from "moment";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Index(props) {
  // Props
  const { promo_codes } = props;

  // States
  const [loading, setLoading] = useState(false);

  // Effects
  useEffect(() => {
    fetchPromoCodes();
  }, []);

  // Functions
  const fetchPromoCodes = async () => {
    try {
      setLoading(true);
      await props.getPromoCodes();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
        <Container>
          <Row>
            <Col
              sm="12"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "1em",
              }}
            >
              {!loading && <h3>Promo Codes</h3>}
              {loading && (
                <div style={{ width: "100px", height: "35px" }}>
                  <BlockLoader
                    width="150px"
                    height="35"
                    innerHeight="100%"
                    innerWidth="100%"
                    style={{ margin: "0", padding: "0" }}
                  />
                </div>
              )}
              <Button
                variant="success"
                size="sm"
                onClick={() => props.history.push(`/admin/promo-codes/create`)}
              >
                Create
              </Button>
            </Col>
            <Col sm="12">
              {!loading && (
                <Table
                  striped
                  bordered
                  hover
                  size="sm"
                  variant="light"
                  responsive="sm"
                  className="promo-table-responsive"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Code</th>
                      <th>Discount</th>
                      <th>Date Created</th>
                      <th>Expiry</th>
                      <th>Status</th>
                      <th>Date Applied</th>
                    </tr>
                  </thead>

                  <tbody>
                    {promo_codes?.data?.map((promo, i) => (
                      <tr key={i}>
                        <td data-label="#">{i + 1}</td>
                        <td data-label="Name">
                          <Link to={`/admin/promo-codes/${promo?.id}`}>
                            {promo.promo_name}
                          </Link>
                        </td>
                        <td data-label="Code">{promo.code}</td>
                        <td data-label="Discount">{promo.discount}%</td>
                        <td data-label="Date Created">
                          {moment
                            .utc(promo.date_created)
                            .utcOffset(0)
                            .format("Do MMM yyy, hh:mm A")}
                        </td>
                        <td data-label="Expiry">
                          {moment
                            .utc(promo.end_date)
                            .utcOffset(0)
                            .format("Do MMM yyy, hh:mm A")}
                        </td>
                        <td data-label="Status">{promo.status === 1 ? "Not Applied" : <Link to={`/admin/users/${promo.updated_by}`}>Applied</Link>}</td>
                        <td data-label="Date Applied">
                          {promo.status === 0
                            ? moment
                                .utc(promo.date_updated)
                                .utcOffset(0)
                                .format("Do MMM yyy, hh:mm A")
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Col>

            <Col sm="12">
              {loading && (
                <BlockLoader
                  width="100%"
                  height="400px"
                  innerWidth="100%"
                  innerHeight="100%"
                />
              )}
            </Col>
          </Row>
        </Container>
      </Col>
      <style>
        {`
        /* Mobile responsive promo table */
        @media (max-width: 768px) {
          .promo-table-responsive thead {
            display: none;
          }

          .promo-table-responsive tr {
            display: block;
            margin-bottom: 1rem;
            border-bottom: 2px solid #ddd;
          }

          .promo-table-responsive td {
            display: flex;
            justify-content: space-between;
            padding: 0.5rem;
            border: none;
            border-bottom: 1px solid #eee;
          }

          .promo-table-responsive td:before {
            content: attr(data-label);
            font-weight: bold;
            flex: 0 0 40%;
            text-align: left;
            color: #333;
          }
        }
        `}
      </style>
    </Layout>
  );
}

const mapStateToProps = (state, ownProps) => {
  return { promo_codes: state.promo_codes };
};

export default connect(mapStateToProps, { getPromoCodes })(withRouter(Index));
